<template>
  <div>
    <div class="container">
      <div class="row justify-content-center">
        <div class="card my-5" style="width:100%">
          <div class="card-body">
            <div class="text-center mb-4">
              <img src="../assets/img/hokodo_logo_color.svg" alt="Hokodo" width="200" height="38.5">
            </div>
            <div v-if="registration_complete" class="text-center mb-4">
              <icon name="check-circle" class="feather-large"></icon>
              <h3 class="my-4">Thank you for signing up</h3>
              <p class="pb-4">A confirmation email was sent to your email address.<br>Please click on the link in the email to complete registration</p>
            </div>
            <form v-else class="form-signin" v-on:submit.prevent="register">
              <p class="mb-3 text-muted text-center">Welcome to the Hokodo partner portal.<br>Register here to get access to and test our APIs.</p>
              <div class="form-group">
                <input type="email" id="inputEmail" class="form-control" placeholder="Email address" v-model="email" v-bind:class="{ 'is-invalid': (error && error.email) }" required autofocus>
                <div class="mb-3 invalid-feedback" v-if="error && error.email">
                  <p v-for="(description,index) in error.email" :key="index">{{description}}</p>
                </div>
              </div>

              <div class="form-group">
                <input type="text" id="inputFullName" class="form-control" v-model="full_name" placeholder="Full name" required>
              </div>

              <div class="form-group" @keyup.enter="register">
                <vue-password v-model="password"
                              id="inputPassword"
                              classes="input form-control"
                              placeholder="Password"
                              :disableStrength="true">
                </vue-password>
                <div class="mb-3 invalid-feedback-password" v-if="error && error.password">
                  <p v-for="(description,index) in error.password" :key="index">{{description}}</p>
                </div>
              </div>

              <button class="btn btn-lg btn-primary btn-block" type="button" v-on:click="register" :disabled="loading"><icon name="settings" class="feather-spin" v-if="loading"></icon> Create your Hokodo account</button>
              <p class="mt-5 mb-3 text-muted text-center">Already have an account? <router-link to="/login">Sign in</router-link></p>
              <hr>
            </form>
          </div>
        </div>
      </div>
    </div>

    <hokodo-footer></hokodo-footer>
  </div>
</template>

<script>
import HokodoFooter from './partials/HokodoFooter'
import VuePassword from 'vue-password'

export default {
  data () {
    return {
      loading: false,
      email: null,
      full_name: null,
      password: null,
      error: null,
      registration_complete: false
    }
  },
  mounted () {

  },
  components: {
    HokodoFooter,
    VuePassword
  },
  methods: {
    register: function () {
      this.loading = true
      this.$store.dispatch('auth/register', {email: this.email, password: this.password, full_name: this.full_name}).then(() => {
        this.registration_complete = true
      }, (error) => {
        // Login failed
        this.loading = false
        this.error = error
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Register.vue